import React from 'react';

import NewsletterAdministrationLayout from 'components/newsletter-administration-layout/NewsletterAdministrationLayout';

import { INewsletterUpdatedPage } from 'source/NFR.types';

const NewsletterUpdatedPage: React.FC<INewsletterUpdatedPage> = ({
  categoriesTitle,
  categoriesList = [],
  emailTitle,
  emailText,
  layout,
  title
}) => (
  <NewsletterAdministrationLayout {...layout} className="newsletter-updated-page">
    {title && <h1>{title}</h1>}
    <div className="newsletter-updated-page--section">
      {emailTitle && <h2>{emailTitle}</h2>}
      <p>{emailText}</p>
    </div>
    <div className="newsletter-updated-page--section">
      {categoriesTitle && <h2>{categoriesTitle}</h2>}
      <ul>
        {categoriesList?.map(category => (
          <React.Fragment key={category.name}>
            <li>
              {category.name}
              {category.description && <div>{category.description}</div>}
            </li>
          </React.Fragment>
        ))}
      </ul>
    </div>
  </NewsletterAdministrationLayout>
);

NewsletterUpdatedPage.displayName = 'NewsletterUpdatedPage';

export default NewsletterUpdatedPage;
